

















































































import { classroomSelectListApi } from "@/api/classRoom";
import { timeTable, timetableTotalApi } from "@/api/schedule";
import { schedulePrint } from "@/utils/schedulePrint";
import { dateFormat } from "@/utils/timeFormat";
import { Component, Prop, Vue } from "vue-property-decorator";
@Component({
  components: {},
})
export default class extends Vue {
  @Prop() showTimeRange!: any[];
  @Prop() printlnWeek_date?: any;
  @Prop() classroom_ids!: any[];
  printDialogVisible: boolean = false; // 打印周课表
  printlnDialogForm: any = {
    week_date: "",
    week_start: "",
    week_end: "",
    totalNum: 0,
  };
  // printlnWeek_date= ""; // 存起来的开始和结束时间
  printlnWeek_start = ""; // 存起来的开始和结束时间
  printlnWeek_end = ""; // 存起来的开始和结束时间
  printClassroomList: any[] = [];
  rules = {
    week_date: [{ required: true, message: "请选择周时间", trigger: "change" }],
  };
  created() {
    const today = new Date();
    // 找周一
    const startDay = new Date(
      today.getTime() -
        (today.getDay() === 0 ? 6 : today.getDay() - 1) * 24 * 60 * 60 * 1000
    );
    // 找周日
    const endDay = new Date(
      today.getTime() +
        (today.getDay() === 0 ? 0 : 7 - today.getDay()) * 24 * 60 * 60 * 1000
    );
    this.printlnWeek_start = dateFormat("YYYY-mm-dd", startDay.getTime());
    this.printlnWeek_end = dateFormat("YYYY-mm-dd", endDay.getTime());
    classroomSelectListApi({
      page: 1,
      page_size: 500,
    }).then((res) => {
      this.printClassroomList = res.data.list;
    });
    if (this.printlnWeek_date) {
      this.printlnDialogForm.week_date = this.printlnWeek_date;
    } else {
      const today = new Date();
      // 找周一
      const startDay = new Date(
        today.getTime() -
          (today.getDay() === 0 ? 6 : today.getDay() - 1) * 24 * 60 * 60 * 1000
      );
      this.printlnDialogForm.week_date = dateFormat(
        "YYYY-mm-dd",
        startDay.getTime()
      );
    }
  }
  handleWeekPrint() {
    this.printDialogVisible = true;
    if (this.printlnWeek_start) {
      this.printlnDialogForm.week_start = this.printlnWeek_start;
    }
    if (this.printlnWeek_end) {
      this.printlnDialogForm.week_end = this.printlnWeek_end;
    }
    // return
    timetableTotalApi({
      start_date: this.printlnDialogForm.week_start,
      end_date: this.printlnDialogForm.week_end,
    }).then((res: any) => {
      if (res.error_code === 0) {
        this.printlnDialogForm.totalNum =
          res.data.roll_call_count + res.data.not_roll_call_count;
      }
    });
  }
  handleDelPrintln() {
    this.printlnDialogForm = {
      week_date: "",
      week_start: "",
      week_end: "",
      totalNum: 0,
    };
    const el: any = this.$refs["println-box"];
    el.style.borderColor = "#f56c6c";
  }
  handleChangePrintlnDate(v: any) {
    const num = new Date(v).getTime();
    this.printlnDialogForm.week_start = dateFormat(
      "YYYY-mm-dd",
      num - 24 * 3600 * 1000
    );
    this.printlnDialogForm.week_end = dateFormat(
      "YYYY-mm-dd",
      num + 5 * 24 * 3600 * 1000
    );
    const el: any = this.$refs["println-box"];
    el.style.borderColor = "#E7E8EA";
    timetableTotalApi({
      start_date: this.printlnDialogForm.week_start,
      end_date: this.printlnDialogForm.week_end,
    }).then((res: any) => {
      if (res.error_code === 0) {
        this.printlnDialogForm.totalNum =
          res.data.roll_call_count + res.data.not_roll_call_count;
      }
    });
  }
  handleSubmit() {
    (this.$refs["ruleFormDom"] as Vue & { validate: Function }).validate(
      (valid: boolean) => {
        if (valid) {
          timeTable({
            start_date: this.printlnDialogForm.week_start,
            end_date: this.printlnDialogForm.week_end,
          }).then((res: any) => {
            if (res.error_code === 0) {
              let classrooms: any = [];
              if (this.classroom_ids.length > 0) {
                classrooms = this.printClassroomList.filter((classroom) => {
                  return classroom.classroom_id === this.classroom_ids;
                });
              } else {
                classrooms = [...this.printClassroomList];
              }
              schedulePrint({
                lessons: res.data.date_list,
                classrooms: classrooms,
                timeRange: this.showTimeRange,
              });
            }
          });
        }
      }
    );
  }
}
